import { useNavigate, useLocation } from "react-router-dom";
import useIdleTimer from "../../hooks/useIdleTimer";

export const IDLE_TIME_MS = 60 * 1000;
const ROUTE_OWNS_IDLE_BEHAVIOR = new Set([
  "/bundle-withdraw",
  "/carrier-validation",
  "/customer-deposit",
]);

export function useRedirectHomeOnIdle() {
  const navigate = useNavigate();
  const location = useLocation();
  useIdleTimer(IDLE_TIME_MS, () => {
    if (
      location.pathname !== "/" &&
      location.pathname !== "/test" &&
      !ROUTE_OWNS_IDLE_BEHAVIOR.has(location.pathname)
    ) {
      navigate("/");
    }
  });
}
